import { TimeScale } from 'store/survey/surveyTypes';
import i18n from '../../../../../../../i18n';

export default {
  annual: 'سالانه',
  twoSeason: 'نیم‌سال',
  getWeek(startOfWeek: string, endOfWeek: string) {
    return i18n.t('fromUntilTo', {
      ns: 'general',
      time1: startOfWeek,
      time2: endOfWeek,
    });
  },
  getSeason(monthNumber: number) {
    switch (true) {
      case monthNumber <= 3:
        return 'بهار';
      case monthNumber > 3 && monthNumber <= 6:
        return 'تابستان';
      case monthNumber > 6 && monthNumber <= 9:
        return 'پاییز';
      case monthNumber > 9 && monthNumber <= 12:
        return 'زمستان';
      default:
        return 'فصل';
    }
  },
  getEnSeason(monthNumber: number) {
    switch (true) {
      case monthNumber <= 3:
        return '1st Quarter';
      case monthNumber > 3 && monthNumber <= 6:
        return '2nd Quarter';
      case monthNumber > 6 && monthNumber <= 9:
        return '3rd Quarter';
      case monthNumber > 9 && monthNumber <= 12:
        return '4th Quarter';
      default:
        return 'Season';
    }
  },
  getTwoSeasonName(monthYear: string) {
    const [month, year] = monthYear.split('-'); // example: 2-97
    const part = Number(month) <= 6 ? 'اول' : 'دوم';
    if (year) {
      return `نیم‌سال ${part} سال ${year}`;
    } else {
      return `نیم‌سال ${part}`;
    }
  },
  getTwoEnSeasonName(monthYear: string) {
    const [month, year] = monthYear.split('-'); // example: 2-97
    const part = Number(month) < 7 ? 'First' : 'Second';
    if (year) {
      return `${part}  half-year / ${year}`;
    } else {
      return `${part}  half-year`;
    }
  },
  getTwoSeasonNameNumber(month: number) {
    const part =
      Number(month) <= 6
        ? i18n.t('first', { ns: 'general' })
        : i18n.t('second', { ns: 'general' });
    return i18n.t('halfYear', { ns: 'general', part });
  },
  getSuperSeasonName(monthNumber: number, year: string) {
    switch (true) {
      case monthNumber <= 3:
        return `بهار ${year}`;
      case monthNumber > 3 && monthNumber <= 6:
        return `تابستان ${year}`;
      case monthNumber > 6 && monthNumber <= 9:
        return `پاییز ${year}`;
      case monthNumber > 9 && monthNumber <= 12:
        return `زمستان ${year}`;
      default:
        return `فصل ${year}`;
    }
  },
  getEndOfWeek(endPeriod: string) {
    return `هفته‌ی متنهی به ${endPeriod}`;
  },
  weeksOf(monthName: string) {
    return i18n.t('weeksOf', { ns: 'survey', monthName });
  },
  getChangeRangeName(periodType: TimeScale) {
    return generateChangeRangeNames(periodType);
  },
};

export const getRangeName: { [key in TimeScale]: string } = {
  day: i18n.t('day', { ns: 'survey' }),
  week: i18n.t('week', { ns: 'survey' }),
  month: i18n.t('month', { ns: 'survey' }),
  season: i18n.t('season', { ns: 'survey' }),
  twoSeason: i18n.t('twoSeason', { ns: 'survey' }),
  year: i18n.t('year', { ns: 'survey' }),
};

const generateChangeRangeNames = (periodType: TimeScale) => {
  const rangeName = getRangeName[periodType];
  return {
    nextTitle: i18n.t('next', { ns: 'survey', time: rangeName }),
    prevTitle: i18n.t('prev', { ns: 'survey', time: rangeName }),
  };
};
